(() => {
  const initialize = () => {
    document.querySelectorAll('[data-pw-detail-variant-map]').forEach((node) => {
      if (node.dataset.initialized) return;
      node.dataset.initialized = 'true';
      let data;
      try { data = JSON.parse(node.textContent); } catch { return; }
      const section = node.closest('.shopify-section');
      const row = section && section.querySelector('[data-pw-detail-refresh]');
      if (!row) return;
      let applied;
      const update = () => {
        const input = document.querySelector('form[action*="/cart/add"] input[name="id"]');
        const id = input ? input.value : data.initial;
        const variant = data.variants.find((item) => String(item.id) === String(id));
        if (!variant) return;
        const color = String(variant.option1 || variant.title).toLowerCase().replace(/^new-/, '');
        const images = data.colors[color];
        if (!images || applied === color) return;
        row.querySelectorAll('[data-pw-detail-block]').forEach((card) => {
          const source = images[card.dataset.pwDetailBlock];
          const image = card.querySelector('img');
          if (!source || !image) return;
          const sourceSet = source.includes('-1140.webp')
            ? [570, 760, 1140].map((width) => `${source.replace('-1140.webp', `-${width}.webp`)} ${width}w`).join(', ')
            : [570, 760, 1140].map((width) => `${source}${source.includes('?') ? '&' : '?'}width=${width} ${width}w`).join(', ');
          image.srcset = sourceSet;
          image.src = source;
          const heading = card.querySelector('h3[data-pw-base-title]');
          const description = card.querySelector('.description');
          const original = card.querySelector('template[data-pw-base-description]');
          const copy = data.copy?.[color]?.[card.dataset.pwDetailBlock];
          if (heading) heading.textContent = copy?.title || heading.dataset.pwBaseTitle;
          if (description && original) {
            if (copy?.description) {
              const paragraph = document.createElement('p');
              paragraph.textContent = copy.description;
              description.replaceChildren(paragraph);
            } else description.innerHTML = original.innerHTML;
          }
          image.alt = `${variant.title} — ${heading ? heading.textContent : image.alt}`;
        });
        row.dataset.pwFeaturedColor = color;
        applied = color;
      };
      document.addEventListener('change', (event) => {
        if (event.target.matches('input[name="id"], variant-radios input, variant-selects select')) queueMicrotask(update);
      });
      window.addEventListener('popstate', update);
      update();
    });
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initialize, { once: true });
  else initialize();
  document.addEventListener('shopify:section:load', initialize);
})();
